import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/index'
import {getToken} from '@/utils/auth'
// 新增：导入产品页面组件
import product from '../views/product/product.vue'
import productItem from '../views/product/prodeuctItem.vue'
import LCCproduct from '../views/lcc/product.vue'
import orderList from '../views/lcc/orderList.vue'
import orderZFG from '../views/insure/orderZFG.vue'
import orderInsZFG from '../views/insure/orderInsZFG.vue'
import orderLYYW from '../views/insure/orderLYYW.vue'
import lccInsure from '../views/lcc/lccInsure.vue'
import lccInsureOrder from '../views/lcc/lccInsureOrder.vue'
import andeCreateInsEIC from '../views/anDeEIC/andeCreateInsEIC.vue'
import andeCreateInsEICSuppSum from '../views/anDeEIC/andeCreateInsEICSuppSum.vue'
import sidebarMenu from '../views/SidebarMenu.vue'
import Login from '../views/Login.vue'
import policyList from '../views/anDeEIC/policyList.vue'
import anDeEICOrderList from '../views/anDeEIC/anDeEICOrderList.vue'
import employeeList from '../views/anDeEIC/employeeList.vue'
import anDeCorrect from '../views/anDeEIC/anDeCorrect.vue'
import modifyPolicy from '../views/anDeEIC/modifyPolicy.vue'
import policyCorrectionList from '../views/anDeEIC/policyCorrectionList.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history', // 新增：启用History模式（去掉#符号）
  routes: [
    // 新增：登录页面路由
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {requiresAuth: false}
    },
    {
      path: '/',
      name: 'index',
      component: index
    },
    // 新增：产品页面路由配置
    {
      path: '/product',
      name: 'product',
      component: product,
      meta: {requiresAuth: true} // 标记需要登录的页面
    },
    {
      path: '/productItem',
      name: 'productItem',
      component: productItem
    },
    {
      path: '/orderZFG',
      name: 'orderZFG',
      component: orderZFG
    },
    {
      path: '/orderInsZFG',
      name: 'orderInsZFG',
      component: orderInsZFG
    },
    {
      path: '/LCCproduct',
      name: 'product',
      component: LCCproduct
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: orderList
    },
    {
      path: '/orderLYYW',
      name: 'orderLYYW',
      component: orderLYYW
    },
    {
      path: '/lccInsure',
      name: 'lccInsure',
      component: lccInsure
    },
    {
      path: '/lccInsureOrder',
      name: 'lccInsureOrder',
      component: lccInsureOrder
    },
    {
      path: '/SidebarMenu',
      name: 'SidebarMenu',
      component: sidebarMenu,
      meta: {requiresAuth: true},
      children: [
        {
          path: 'policyList',
          name: 'PolicyList',
          component: policyList,
          meta: {requiresAuth: true}
        },
        {
          path: 'modifyPolicy',
          name: 'ModifyPolicy',
          component: modifyPolicy,
          meta: {requiresAuth: true}
        },
        {
          path: 'andeCreateInsEIC',
          name: 'AndeCreateInsEIC',
          component: andeCreateInsEIC,
          meta: {requiresAuth: true}
        },
        {
          path: 'andeCreateInsEICSuppSum',
          name: 'AndeCreateInsEICSuppSum',
          component: andeCreateInsEICSuppSum,
          meta: {requiresAuth: true}
        },
        {
          path: 'anDeEICOrderList',
          name: 'AnDeEICOrderList',
          component: anDeEICOrderList,
          meta: {requiresAuth: true}
        },
        {
          path: 'employeeList',
          name: 'EmployeeList',
          component: employeeList,
          meta: {requiresAuth: true}
        },
        {
          path: 'anDeCorrect',
          name: 'AnDeCorrect',
          component: anDeCorrect,
          meta: {requiresAuth: true}
        },
        {
          path: 'policyCorrectionList',
          name: 'PolicyCorrectionList',
          component: policyCorrectionList,
          meta: {requiresAuth: true}
        }

      ]
    }
  ]
})

// 全局前置守卫：检查 token 状态
router.beforeEach(async (to, from, next) => {
  console.log('全局前置守卫：检查 token 状态')
  // 判断路由是否需要登录权限
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查是否已登录
    const token = getToken()
    if (!token) {
      // 未登录，重定向到登录页
      next({
        path: '/login',
        query: {redirect: to.fullPath} // 记录当前路径，登录后跳转回来
      })
    } else {
      // 已登录，继续访问
      next()
    }
  } else {
    // 不需要登录的路由直接放行
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js